import { createContext, useState } from 'react';

const TransitionViewContext = createContext({});

function TransitionViewProvider({ children }) {
  const [diffDeptStaffCache, setDiffDeptStaffCache] = useState(new Map());

  return (
    <TransitionViewContext.Provider value={{ diffDeptStaffCache, setDiffDeptStaffCache }}>
      {children}
    </TransitionViewContext.Provider>
  );
}

export { TransitionViewContext, TransitionViewProvider };
